// extracted by mini-css-extract-plugin
export default {"messageContainer":"ValidationMessage_messageContainer__EaUJs","error":"ValidationMessage_error__QsPQC","warning":"ValidationMessage_warning__ZtM2k"};